import React from 'react';

import ProgressBar from 'js/components/progress_bar';

import 'scss/layout.scss';
import './index.scss';

export default function CampaignContentProgress({approved = 0, pending = 0, required = 0}) {
    let total;
    if (approved + pending === required) {
        total = required;
    } else if (approved + pending > required) {
        total = approved + pending;
    } else {
        total = required;
    }

    return (
        <div className="campaign-content-progress layout-stack">
            <div className="campaign-content-progress__bar">
                <ProgressBar total={total}>
                    <ProgressBar.Segment value={approved} color="downy" />
                    <ProgressBar.Segment value={pending} color="casablanca" />
                </ProgressBar>
            </div>
            <div className="layout-row--center campaign-content-progress__info">
                <div className='layout-row--center campaign-content-progress__info--item'>
                    <div className='ball ball--approved' />
                    <span>Approved: {approved}</span> 
                </div>
                <div className='layout-row--center campaign-content-progress__info--item'>
                    <div className='ball ball--pending' />
                    <span>Waiting for approval: {pending}</span> 
                </div>
                <div className='layout-row--center campaign-content-progress__info--item'>
                    <div className='ball' />
                    <span>Goal: {Math.round(required)}</span> 
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/campaign_content_progress/index.js